import { Alert, Box, useTheme } from "@mui/material";

import ActionsView from "@/Actions/components/action/ActionsView";
import { Capability } from "@/Actions/components/action/types";
import { useAuth } from "@/providers";
import { PageLayout } from "@/shared/components/PageLayout";
import { Accessibility } from "@/shared/domain/actions";

const ACTION_VIEW_CAPABILITIES = [Capability.Invoke];

export function ActionHub() {
  const { currentOrganization } = useAuth();
  const theme = useTheme();

  return (
    <PageLayout title="Roboto - Action Hub" headerContentLeft="Action Hub">
      <Box marginBottom={theme.spacing(2.5)}>
        <Alert severity="info">
          Actions in the Action Hub have been published by Roboto and other
          organizations and are available to invoke on your own datasets.
        </Alert>
      </Box>
      <div>
        <ActionsView
          accessibility={Accessibility.ActionHub}
          capabilities={ACTION_VIEW_CAPABILITIES}
          org={currentOrganization}
        />
      </div>
    </PageLayout>
  );
}
